/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * OpenAPI spec version: Latest
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { PlannerHelpVideoResponse } from '../models';
import { PlannerWeekFindResponse } from '../models';
import { PlannerWeekResponse } from '../models';
/**
 * PlannerApi - axios parameter creator
 * @export
 */
export const PlannerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets help video id and copy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlannerHelpVideoGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Planner/HelpVideo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a week view of the planner. For Stage and Week, only send the number.
         * @param {string} [year] 
         * @param {string} [stage] 
         * @param {string} [week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlannerWeekFindGet: async (year?: string, stage?: string, week?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Planner/WeekFind`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (year !== undefined) {
                localVarQueryParameter['Year'] = year;
            }

            if (stage !== undefined) {
                localVarQueryParameter['Stage'] = stage;
            }

            if (week !== undefined) {
                localVarQueryParameter['Week'] = week;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a week view of the planner
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlannerWeekGet: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Planner/Week`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlannerApi - functional programming interface
 * @export
 */
export const PlannerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets help video id and copy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlannerHelpVideoGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlannerHelpVideoResponse>> {
            const localVarAxiosArgs = await PlannerApiAxiosParamCreator(configuration).apiPlannerHelpVideoGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a week view of the planner. For Stage and Week, only send the number.
         * @param {string} [year] 
         * @param {string} [stage] 
         * @param {string} [week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlannerWeekFindGet(year?: string, stage?: string, week?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlannerWeekFindResponse>> {
            const localVarAxiosArgs = await PlannerApiAxiosParamCreator(configuration).apiPlannerWeekFindGet(year, stage, week, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a week view of the planner
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlannerWeekGet(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlannerWeekResponse>> {
            const localVarAxiosArgs = await PlannerApiAxiosParamCreator(configuration).apiPlannerWeekGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PlannerApi - factory interface
 * @export
 */
export const PlannerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Gets help video id and copy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlannerHelpVideoGet(options?: any): AxiosPromise<PlannerHelpVideoResponse> {
            return PlannerApiFp(configuration).apiPlannerHelpVideoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a week view of the planner. For Stage and Week, only send the number.
         * @param {string} [year] 
         * @param {string} [stage] 
         * @param {string} [week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlannerWeekFindGet(year?: string, stage?: string, week?: string, options?: any): AxiosPromise<PlannerWeekFindResponse> {
            return PlannerApiFp(configuration).apiPlannerWeekFindGet(year, stage, week, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a week view of the planner
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlannerWeekGet(id?: string, options?: any): AxiosPromise<PlannerWeekResponse> {
            return PlannerApiFp(configuration).apiPlannerWeekGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlannerApi - object-oriented interface
 * @export
 * @class PlannerApi
 * @extends {BaseAPI}
 */
export class PlannerApi extends BaseAPI {
    /**
     * 
     * @summary Gets help video id and copy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlannerApi
     */
    public apiPlannerHelpVideoGet(options?: any) {
        return PlannerApiFp(this.configuration).apiPlannerHelpVideoGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a week view of the planner. For Stage and Week, only send the number.
     * @param {string} [year] 
     * @param {string} [stage] 
     * @param {string} [week] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlannerApi
     */
    public apiPlannerWeekFindGet(year?: string, stage?: string, week?: string, options?: any) {
        return PlannerApiFp(this.configuration).apiPlannerWeekFindGet(year, stage, week, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a week view of the planner
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlannerApi
     */
    public apiPlannerWeekGet(id?: string, options?: any) {
        return PlannerApiFp(this.configuration).apiPlannerWeekGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}
